import { Box, Button, ClickAwayListener, MenuItem, MenuList, Popper, Typography, useTheme } from '@mui/material'
import { observer } from 'mobx-react'
import { useMemo, useRef, useState } from 'react'
import { useAdmissionExamStore } from '../../store/admission-exam.store'
import { Icons } from '../../utils/utilities'
import { by639_1 } from 'iso-language-codes'
import { useTranslation } from 'react-i18next'

const LanguageSelector = observer( ( { variant = "outlined", showNote = false } ) => {

    const [languageOptionsOpen, setLanguageOptionsOpen] = useState( false )

    const { palette, shadows } = useTheme()
    const { t, i18n } = useTranslation()

    const buttonStyles = useMemo( () => {
        if ( variant === "outlined" )
            return { borderRadius: "10px", border: `1px solid ${palette.text.secondary}`, background: "none", color: palette.text.primary }
        if ( variant === "dark" )
            return { borderRadius: "10px", border: `1px solid ${palette.primary.main}`, background: palette.primary.main, color: palette.primary.contrastText }
        else
            return { borderRadius: "10px", bgcolor: palette.common.white, color: palette.common.black }
    }, [variant] )

    const ExamStore = useAdmissionExamStore()

    const languageOptionsButtonRef = useRef()
    const languageSelectorRef = useRef()

    const { translationsAvailable = false, translationLanguges = [], selectedLanguage = "" } = ExamStore.getTranslationDetails || {}

    const handleLanguageChange = ( lang ) => {
        ExamStore.setExamQuestionsLanguage( lang )
        i18n.changeLanguage( lang || "cimode" )
    }

    return (
        <Box ref={languageSelectorRef}>

            {translationsAvailable && <Popper sx={{ zIndex: 100 }} container={languageSelectorRef.current} placement='bottom-start' open={languageOptionsOpen} anchorEl={languageOptionsButtonRef.current} >
                <ClickAwayListener onClickAway={() => setLanguageOptionsOpen( false )}>
                    <Box boxShadow={shadows[1]} marginTop="5px" borderRadius="5px" overflow="clip" bgcolor={palette.background.paper}>
                        <MenuList dense>
                            {translationLanguges.map( lang => {
                                const languageDetails = by639_1[lang.toLowerCase()]
                                return (
                                    <MenuItem dense onClick={() => handleLanguageChange( lang )} selected={lang === selectedLanguage} key={lang}>
                                        <Typography fontSize="14px" component="span" color={lang === selectedLanguage ? palette.primary.contrastText : palette.common.black}>{lang.toUpperCase()} {languageDetails?.nativeName ? `- ${languageDetails?.nativeName}` : ""}</Typography>
                                    </MenuItem>
                                )
                            } )}
                        </MenuList>
                    </Box>
                </ClickAwayListener>
            </Popper>}
            {translationsAvailable && <Button endIcon={Icons.default.KeyboardArrowDownIcon} onClick={() => setLanguageOptionsOpen( true )} ref={languageOptionsButtonRef} variant='contained' size='small' disableElevation sx={buttonStyles} startIcon={Icons.default.Language}>
                {t( "label.examLanguage" )}: {selectedLanguage?.toUpperCase()}
            </Button>}

            {showNote && <Typography display="block" marginTop="5px" variant='caption'> {Icons.default.Info} {t( "message.examLanguageSelectNote" )}</Typography>}

        </Box>
    )
} )

export default LanguageSelector